import React, { Component } from "react";
import { Helmet } from "react-helmet";

class PageHelmet extends Component {
  render() {
    return (
      <React.Fragment>
        <Helmet>
          <title>Acar Elektrik </title>
          <meta name="description" content="" />
        </Helmet>
      </React.Fragment>
    );
  }
}

export default PageHelmet;
